import { render } from "./Memory.Utilization.vue?vue&type=template&id=071bc018&scoped=true"
import script from "./Memory.Utilization.vue?vue&type=script&lang=js"
export * from "./Memory.Utilization.vue?vue&type=script&lang=js"

import "./Memory.Utilization.vue?vue&type=style&index=0&id=071bc018&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EZELINK\\Wajiha\\Projects\\EzenmsV2_vueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071bc018"]])

export default __exports__